module.exports = __webpack_public_path__ + "media/images/flags/16/Antarctica-7e19ca8ddb5e6e2258ac02e3d07116c7.png";